<!--
 * @Author: wanghaipeng 1595678040@qq.com
 * @Date: 2022-06-22 18:49:40
 * @LastEditors: wanghaipeng 1595678040@qq.com
 * @LastEditTime: 2022-06-22 19:15:39
 * @FilePath: \jingdata-t-web\src\investment\components\metaData\krEditor\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <Toolbar
      :editor="editor"
      :defaultConfig="toolbarConfig"
      :mode="mode"
    >
    </Toolbar>
    <Editor
      class="kr-ditor"
      style=" overflow-y: hidden;border: 1px solid #ccc"
      :style="{ height }"
      v-model="_value"
      :defaultConfig="editorConfig"
      :mode="mode" 
      @onCreated="onCreated"
    />
  </div>
</template>
<script>
import { Editor, Toolbar } from './@wangeditor/editor-for-vue'
import { fontSizeMap, fontSizeList } from './fontsize.js'
// import { IButtonMenu,Boot,createToolbar  } from '@wangeditor/editor'

export default {
  components: {
    Editor, 
    Toolbar
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '400px'
    },
    toolbarConfig: {
      type: Object,
      default() {
        return {
           toolbarKeys: [
            'bold', 
            'underline', 
            'italic', 
            'through', 
            'clearStyle', 
            'fontFamily',
            'fontSize', 
            'lineHeight',
            'indent', 
            'delIndent',
            'color',
          ]
        }
      }
    },
    editorConfig: {
      type: Object,
      default() {
        return { 
          placeholder: '请输入内容...',
          MENU_CONF: {
            fontSize: {
              fontSizeList:  [
                // 元素支持两种形式：1. 字符串；2. { name: 'xxx', value: 'xxx' }
                // 对象不知道为什么不生效，故修改了源码，本地打包编译的源码
                ...fontSizeList
              ]
            }
          }
        }
      },
    },
    mode: {
      type: String,
      default: 'simple'
    },
  },
  data() {
    return {
      editor: null,
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
  methods: {
    onCreated(editor) {
      const menu = editor.getMenuConfig('fontFamily')


      // let me = this
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
      //   class MyButtonMenu {   
      //   constructor() {
      //     this.title = "上传附件"
      //     this.tag = 'button'
      //     this.showDropPanel = true
      //   }
      //   getValue(editor) {                              // JS 语法
      //       return ' hello '
      //   }
      //   isActive(editor) {
      //         return false // or true
      //   }
      //   isDisabled(editor) {
      //         return false // or true
      //   }
      //   exec(editor, value) {    
        
      //   }
      //   getPanelContentElem(editor) {                        // JS 语法
      //     const $list = $(`<ul class="listCls">
      //       <li data-id="1" class="onceLi filesHome">从文件库中选择</li> <li class="computedUpload onceLi" data-id="2">从本地上传<input class="computedUploadInput" type="file"/></li> 
      //     </ul>`)
          
      //     // 从文件库选择
      //     $list.on('click', '.filesHome', function () {
      //       editor.insertText(' ')
      //       me.documentLibrary(this)
      //     })
      //     // 从本地上传
      //     $list.on('click', '.computedUpload', function () {
      //       editor.insertText('')
      //       me.localLibrary(this)
      //     })

      //   return $list[0] // 返回 DOM Element 类型

      //   // PS：也可以把 $list 缓存下来，这样不用每次重复创建、重复绑定事件，优化性能
      //   }
      // }
      // // 获取所有配置项,因为菜单只可以注册一次
      // let menuConfig = this.editor.getConfig()
      // let keys = 'myMenu'
      // let keyFlag = false
      // for(let key in menuConfig.MENU_CONF){
      //   if(keys === key){
      //     keyFlag = true 
      //   }else{
      //     keyFlag = false 
      //   }
      // }
      // // 所以需要做判断,如果已经注册过,什么操作都不做
      // // 如果没有注册过,那么注册自定义菜单
      // if(!keyFlag){
      //   const myMenuConf  = {
      //       key: 'myMenu', // 定义 menu key ：要保证唯一、不重复（重要）
      //       factory() {
      //         return new MyButtonMenu() 
      //       },
      //     }
      //   // 注册菜单
      //   Boot.registerMenu(myMenuConf);
      // }
      // // 放到配置项中
      // this.toolbarConfig.toolbarKeys.push('myMenu')

     

      editor.on('modalOrPanelShow', modalOrPanel => { 
        // 修改字号弹窗显示默认字体大小
        let length = $($(modalOrPanel.$elem[0])).find('ul li').length
        for (let i = 1; i < length; i++) {
          let li = $($(modalOrPanel.$elem[0])).find('ul li').get(i)
          $(li).attr('style', '')
        }
      })

 

    },
    // // 从文件库选择
    // documentLibrary(ev){
    //   this.$emit('editorMymenu',true)
    // },
    // // 从本地选择
    // localLibrary(ev){
    //   console.log(ev)
    // }
  }
}
</script>
<style src="./@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>
/deep/ strong {
  font-weight: bolder !important;
}
/deep/ .listCls{
  .onceLi{
    height: 30px;
    line-height: 30px;
    cursor: pointer;
  }
  .computedUpload {
  position: relative;
  .computedUploadInput{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    opacity: 0;
    cursor: pointer;
  }
}
}

</style>
